//-------------------------------------BANNERS-------------------------------------//
export const DEACTIVATE_BANNER                           = 'DEACTIVATE_BANNER';
export const ACTIVATE_BANNER                             = 'ACTIVATE_BANNER';
export const UPDATE_BANNER                               = 'UPDATE_BANNER';
export const CREATE_BANNER                               = 'CREATE_BANNER';
export const GET_BANNERS                                 = 'GET_BANNERS';
//-------------------------------------NOTIFICATIONS-------------------------------------//
export const CREATE_NOTIFICATION                         = 'CREATE_NOTIFICATION';
export const UPDATE_NOTIFICATION                         = 'UPDATE_NOTIFICATION';
export const DELETE_NOTIFICATION                         = 'DELETE_NOTIFICATION';
export const GET_NOTIFICATIONS                           = 'GET_NOTIFICATIONS';
//-------------------------------------CATEGORIAS-------------------------------------//
export const DEACTIVATE_CATEGORIES                       = 'DEACTIVATE_CATEGORIES';
export const ACTIVATE_CATEGORIES                         = 'ACTIVATE_CATEGORIES';
export const UPDATE_CATEGORIES                           = 'UPDATE_CATEGORIES';
export const CREATE_CATEGORIES                           = 'CREATE_CATEGORIES';
export const GET_CATEGORIES                              = 'GET_CATEGORIES';
//-------------------------------------SUBCATEGORIAS-------------------------------------//
export const DEACTIVATE_SUBCATEGORIES                    = 'DEACTIVATE_SUBCATEGORIES';
export const ACTIVATE_SUBCATEGORIES                      = 'ACTIVATE_SUBCATEGORIES';
export const GET_SUBCATEGORIESPAG                        = 'GET_SUBCATEGORIESPAG';
export const UPDATE_SUBCATEGORIES                        = 'UPDATE_SUBCATEGORIES';
export const CREATE_SUBCATEGORIES                        = 'CREATE_SUBCATEGORIES';
export const GET_SUBCATEGORIES                           = 'GET_SUBCATEGORIES';
//-------------------------------------PRODUCT-------------------------------------//
export const PRODUCTS_WITH_IMAGES                        = 'PRODUCTS_WITH_IMAGES';
export const MARK_AS_COMPLETED                           = 'MARK_AS_COMPLETED';
export const GET_ALL_PRODUCTS                            = 'GET_ALL_PRODUCTS';
export const PENDIG_IMAGES                               = 'PENDIG_IMAGES';
export const DELETE_IMAGES                               = 'DELETE_IMAGES';
export const UPLOAD_IMAGE                                = 'UPLOAD_IMAGE';
export const UPLOAD_FILE                                 = 'UPLOAD_FILE';
//-------------------------------------PRODUCT_IMAGE_SAVED-------------------------------------//
export const PRODUCT_IMAGE_SAVED                         = 'PRODUCT_IMAGE_SAVED';
//-------------------------------------FEATURED_PRODUCT-------------------------------------//
export const DEACTIVATE_FEATURED_PRODUCTS                = 'DEACTIVATE_FEATURED_PRODUCTS';
export const UPDATE_FEATURED_PRODUCTS                    = 'UPDATE_FEATURED_PRODUCTS';
export const FEATURED_PRODUCTS                           = 'FEATURED_PRODUCTS';
//-------------------------------------OPENPAY-------------------------------------//
export const GETOPENPAYCREDENTIALS                       = 'GETOPENPAYCREDENTIALS';
export const GETWITHOUTOPENPAY                           = 'GETWITHOUTOPENPAY';
export const UPDATEASSOCIATION                           = 'UPDATEASSOCIATION';
export const DELETEASSOCIATION                           = 'DELETEASSOCIATION';
export const ASSOCIATEOPENPAY                            = 'ASSOCIATEOPENPAY';
export const GETWITHOPENPAY                              = 'GETWITHOPENPAY';
//-------------------------------------USERS-------------------------------------//
export const DELETE_USER                                 = 'DELETE_USER';
export const UPDATE_USER                                 = 'UPDATE_USER';
export const CREATE_USER                                 = 'CREATE_USER';
export const GET_USERS                                   = 'GET_USERS';
//-------------------------------------CENTERS-------------------------------------//
export const GET_CENTROS_BY_PAGINATOR                    = 'GET_CENTROS_BY_PAGINATOR';
export const REFACTOR_CENTER                             = 'REFACTOR_CENTER';
export const CREATE_CENTER                               = 'CREATE_CENTER';
export const UPDATE_CENTER                               = 'UPDATE_CENTER';
export const DELETE_CENTER                               = 'DELETE_CENTER';
export const GET_CENTROS                                 = 'GET_CENTROS';
//-------------------------------------ROL-------------------------------------//
export const DEACTIVATE_ROL                              = 'DEACTIVATE_ROL';
export const ACTIVATE_ROL                                = 'ACTIVATE_ROL';
export const UPDATE_ROL                                  = 'UPDATE_ROL';
export const CREATE_ROL                                  = 'CREATE_ROL';
export const GET_ROLES                                   = 'GET_ROLES';
//-------------------------------------FACULTY-------------------------------------//
export const DEACTIVATE_FACULTY                          = 'DEACTIVATE_FACULTY';
export const ACTIVATE_FACULTY                            = 'ACTIVATE_FACULTY';
export const UPDATE_FACULTY                              = 'UPDATE_FACULTY';
export const CREATE_FACULTY                              = 'CREATE_FACULTY';
export const GET_FACULTIES                               = 'GET_FACULTIES';
//-------------------------------------DENY-------------------------------------//
export const DEACTIVATE_DENY                             = 'DEACTIVATE_DENY';
export const ACTIVATE_DENY                               = 'ACTIVATE_DENY';
export const UPDATE_DENY                                 = 'UPDATE_DENY';
export const CREATE_DENY                                 = 'CREATE_DENY';
export const GET_DENIALS                                 = 'GET_DENIALS';
//-------------------------------------CENTER_CONFIGURATION-------------------------------------//
export const GET_BY_INNER_BRANCH_ID_CENTER_CONFIGURATION = 'GET_BY_INNER_BRANCH_ID_CENTER_CONFIGURATION';
export const UPDATE_CENTER_CONFIGURATION                 = 'UPDATE_CENTER_CONFIGURATION';
//-------------------------------------USER_CONFIGURATION-------------------------------------//
export const GET_BY_USER_ID_CONFIGURATION                = 'GET_BY_USER_ID_CONFIGURATION';
export const UPDATE_USER_CONFIGURATION                   = 'UPDATE_USER_CONFIGURATION';
//-------------------------------------API-------------------------------------//
export const GET_API_SYNC_GENERAL_STATUS                 = 'GET_API_SYNC_GENERAL_STATUS';
export const GET_API_SYNC_STOCK_STATUS                   = 'GET_API_SYNC_STOCK_STATUS';
export const GET_API_STADISTICS_STATUS                   = 'GET_API_STADISTICS_STATUS';
export const GET_API_MAIN_STATUS                         = 'GET_API_MAIN_STATUS';
export const GET_JOB_LOGS                                = 'GET_JOB_LOGS';
//-------------------------------------COMMON-------------------------------------//
export const GET_ERRORS                                  = 'GET_ERRORS';
//-------------------------------------LEGACY-------------------------------------//
export const SET_CURRENT_USER                            = 'SET_CURRENT_USER';
export const CLIENTS_LOADING                             = 'CLIENTS_LOADING';
export const CLIENT_LOADING                              = 'CLIENT_LOADING';
export const USER_REGISTER                               = 'USER_REGISTER';
export const USER_LOADING                                = 'USER_LOADING';
export const SET_MESSAGE                                 = 'SET_MESSAGE';
export const GET_CLIENT                                  = 'GET_CLIENT';
//-------------------------------------ADDRESS_MANAGEMENT_PER_USER-------------------------------------//
export const GET_SOCIAL_REASON_DETAIL                    = 'GET_SOCIAL_REASON_DETAIL';
export const GET_USER_SOCIAL_REASONS                     = 'GET_USER_SOCIAL_REASONS';
export const GET_DELIVERY_ADDRESSES                      = 'GET_DELIVERY_ADDRESSES';
export const UPDATE_SOCIAL_REASON                        = 'UPDATE_SOCIAL_REASON';
export const CREATE_SOCIAL_REASON                        = 'CREATE_SOCIAL_REASON';
export const DELETE_SOCIAL_REASON                        = 'DELETE_SOCIAL_REASON';
export const DEACTIVATE_BRANCH                           = 'DEACTIVATE_BRANCH';
export const GET_BRANCH_DETAIL                           = 'GET_BRANCH_DETAIL';
export const ACTIVATE_BRANCH                             = 'ACTIVATE_BRANCH';
export const CREATE_BRANCH                               = 'CREATE_BRANCH';
export const UPDATE_BRANCH                               = 'UPDATE_BRANCH';










